var _defs, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpContact = function SvgHelpContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "help-contact_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".help-contact_svg__cls-3{fill:#ed1c24}"))), /*#__PURE__*/React.createElement("path", {
    d: "M-1.09.24h500.3v500.55H-1.09z",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23 403.37 156 357.19a25.16 25.16 0 0 1 12.83-3.54h200.4c15 0 27.11-13.21 27.11-29.5V173.23c0-16.29-12.14-29.49-27.11-29.49H130.74c-15 0-27.11 13.2-27.11 29.49V397.8c0 4.81 4.72 7.86 8.6 5.57Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 14
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181.22,
    cy: 243.73,
    r: 20.39,
    className: "help-contact_svg__cls-3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.83,
    cy: 243.73,
    r: 20.39,
    className: "help-contact_svg__cls-3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.44,
    cy: 243.73,
    r: 20.39,
    className: "help-contact_svg__cls-3"
  })));
};
export default SvgHelpContact;